import type { Tour } from '../tour-types';

/**
 * The survey builder, for a new survey and for editing one. Every step's fields stay
 * mounted in one form, but only the open step is visible, and the builder always opens on
 * Template. So the tour covers the step strip, the Template step's two fields, the preview
 * and the actions; Questions, Targeting, Trigger and Theme are hidden at the start and get no steps.
 */
export const surveyBuilderTour: Tour = {
  key: 'surveys.builder',
  version: 1,
  routes: ['/surveys/new', '/surveys/:id/edit'],
  steps: [
    {
      anchor: 'survey-builder-steps',
      placement: 'bottom',
      title: 'Five steps',
      body: 'Template, then the questions, who sees it, when it appears, and how it looks. Jump to any step at any time; a tick marks one that is done.',
    },
    {
      anchor: 'survey-builder-type',
      placement: 'bottom',
      title: 'What to measure',
      body: 'NPS for loyalty, CSAT for satisfaction and CES for effort, each with its own scale and wording, or Custom for your own questions. On a new survey, picking one starts it over from that template, so choose it first. Once a survey has run, its type is fixed.',
    },
    {
      anchor: 'survey-builder-name',
      placement: 'bottom',
      title: 'Internal name',
      body: 'How the survey is listed in your library. Visitors never see it.',
    },
    {
      anchor: 'survey-builder-preview',
      placement: 'left',
      title: 'Preview',
      body: 'A close likeness of what visitors will see, updated as you edit. The real widget is drawn on your own site.',
    },
    {
      anchor: 'survey-builder-actions',
      placement: 'top',
      title: 'Continue and save',
      body: 'Continue moves to the next step; if it is greyed out, the line below says what is missing. A new survey is saved as a draft, so nobody sees it until you start it.',
    },
  ],
};
